// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WHVnZ_ {
  display: flex;
  align-items: center;
  gap: var(--header-gap, 12px);
  padding: var(--header-padding, 0 24px);
  height: var(--header-height, 64px);
  background-color: var(--background-white, #ffffff);
  border-bottom: 1px solid var(--surface-neutral-subtle, #f2f2f2);
}

.Pzu2DQ {
  position: relative;
  cursor: pointer;
}

.k43ROY {
  position: absolute;
  top: 100%;
  z-index: 1000;
  margin-top: 8px;
  /* Padding para garantir que a sombra do ProfileMenu não seja cortada */
  padding: 0 12px 12px 12px;
}

.zC5pNw {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px;
}

.BIwEJC {
  font-size: 12px;
  line-height: 1.424;
  color: var(--header-company-selector-text-color);
  white-space: nowrap;
  display: flex; /* Mantém o flex */
  justify-content: space-between; /* Empurra o label para um lado e o número para o outro */
  width: 100%; /* Garante que ele ocupe toda a largura do container pai */
  font-weight: 400;

  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');

  margin: 0;
  height: 16px;
}

.BIwEJC label {
  color: var(--header-company-selector-text-color);
  font-weight: 600;
  padding-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppHeaderRight/AppHeaderRight.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,kDAAkD;EAClD,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,eAAe;EACf,uEAAuE;EACvE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gDAAgD;EAChD,mBAAmB;EACnB,aAAa,EAAE,kBAAkB;EACjC,8BAA8B,EAAE,yDAAyD;EACzF,WAAW,EAAE,0DAA0D;EACvE,gBAAgB;;EAEhB,iEAAiE;;EAEjE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: var(--header-gap, 12px);\n  padding: var(--header-padding, 0 24px);\n  height: var(--header-height, 64px);\n  background-color: var(--background-white, #ffffff);\n  border-bottom: 1px solid var(--surface-neutral-subtle, #f2f2f2);\n}\n\n.avatarContainer {\n  position: relative;\n  cursor: pointer;\n}\n\n.profileMenuContainer {\n  position: absolute;\n  top: 100%;\n  z-index: 1000;\n  margin-top: 8px;\n  /* Padding para garantir que a sombra do ProfileMenu não seja cortada */\n  padding: 0 12px 12px 12px;\n}\n\n.accountInfo {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0px;\n}\n\n.accountText {\n  font-size: 12px;\n  line-height: 1.424;\n  color: var(--header-company-selector-text-color);\n  white-space: nowrap;\n  display: flex; /* Mantém o flex */\n  justify-content: space-between; /* Empurra o label para um lado e o número para o outro */\n  width: 100%; /* Garante que ele ocupe toda a largura do container pai */\n  font-weight: 400;\n\n  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');\n\n  margin: 0;\n  height: 16px;\n}\n\n.accountText label {\n  color: var(--header-company-selector-text-color);\n  font-weight: 600;\n  padding-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WHVnZ_`,
	"avatarContainer": `Pzu2DQ`,
	"profileMenuContainer": `k43ROY`,
	"accountInfo": `zC5pNw`,
	"accountText": `BIwEJC`
};
module.exports = ___CSS_LOADER_EXPORT___;
